import React, { useEffect } from "react";
import { Field, reduxForm, change } from "redux-form";
import { useDispatch } from "react-redux";
import moment from "moment";
import DateTimeInput from "../../../../../Components/Forms/datetime";
import { required } from "redux-form-validators";

const ChangeVertrek = ({ handleSubmit, vertrektijd, vertrekdatum }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!vertrekdatum) return;

      const vertrekMorgen = moment(vertrekdatum).add(1, "day").toDate();
      dispatch(change("changevertrek", "vertrek", vertrekMorgen));
   
  }, [vertrektijd, dispatch]);

  return (
    <form onSubmit={handleSubmit} className="kwh-settings p-2 mt-4">
      <h4 className="m-0">Vertrekdatum wijzigen</h4>

      <Field name="vertrek" minDate={new Date()} minTime={true} component={DateTimeInput} type="input" timeIntervals="15" label="Vertrek datum verblijf" validate={required({ msg: "Dit item is verplicht" })} />

      <div className="box-footer">
        <button type="submit" className="btn btn-primary">
          Verzenden
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "changevertrek",
})(ChangeVertrek);
